import { UiGroupControl } from "./ui-group-control.model";
import { TabOptions } from '../../interfaces/tab-option.interface';

export class TabControl extends UiGroupControl {

  tabOptions: TabOptions;
  parentEntityId: string;

  constructor(options: TabOptions) {
    super(options.name, options.label);

    this.className = "TabControl";
    this.tabOptions = options;
  }

}
